import React from "react";
import RegisterCompanyForm from "../../components/authCompany/RegisterCompanyForm";

function RegisterCompany(props) {
  return (
    <RegisterCompanyForm />
  );
}

export default RegisterCompany;
